import { isTouch } from '../utils/helpers';
import { onWindowResize } from '../utils/windowResize';

export const mouse = {
    x: window.innerWidth / 2,
    y: window.innerHeight / 2,
};

export function setupCanvas() {
    if (!isTouch) {
        const canvasMouseTriggers = document.querySelectorAll('.product-slider,.inspiration,.entrance,.related-articles,.gallery');
        const scaleTriggers = document.querySelectorAll('.product-slider__list,.inspiration__list,.article-list--small .article-list__item,.gallery__list-wrap');
        const canvas = document.querySelector('.canvas');
        let hoverScaleTrigger = false;

        if (canvas) {
            function Circle(x, y, radius) {
                this.x = x;
                this.y = y;
                this.radius = radius;
                hoverRadius = 74;
                this.lastMouse = {x: x, y: y};
                newRadius = radius;

                this.update = () => {
                    // Drag effect
                    this.lastMouse.x += (mouse.x - this.lastMouse.x) * 0.1;
                    this.lastMouse.y += (mouse.y - this.lastMouse.y) * 0.1;

                    // Circular motion
                    this.x = this.lastMouse.x;
                    this.y = this.lastMouse.y;

                    this.draw();
                };

                this.draw = () => {
                    if (hoverScaleTrigger && newRadius < hoverRadius) {
                        newRadius += 4;
                    } else if (!hoverScaleTrigger && newRadius > this.radius) {
                        newRadius -= 4;
                    }

                    const newX = this.x + (newRadius / 2) + 5;

                    c.clearRect(0, 0, canvas.width, canvas.height);

                    if (
                        newRadius > (this.radius * 2) &&
                        (
                            canvasText.length > 1 ||
                            canvasIcon.length > 1
                        )
                    ) {
                        c.fillStyle = 'rgba(255,255,255,1)';
                    } else {
                        c.fillStyle = 'rgba(255,255,255,1)';
                    }

                    c.beginPath();
                    c.arc(newX, this.y, newRadius, Math.PI * 2, false);
                    c.fill();
                    c.closePath();

                    if (newRadius > (this.radius * 2) && canvasText.length > 1) {
                        c.fillStyle = 'rgba(0,0,0,1)';
                        c.font = "18px synthese";
                        c.fillText(canvasText, newX - 26, this.y + 7);
                    }

                    if (newRadius > (this.radius * 2) && canvasIcon.length > 1) {
                        c.drawImage(img, newX - 19, this.y - 8, 38, 17);
                    }
                };
            }

            function requestTick() {
                if (!ticking) {
                    requestAnimationFrame(animate);
                    ticking = true;
                }
            }

            function animate() {
                if (!canceled) {
                    if (hoverTarget != '') {
                        if (hoverTarget.hasAttribute('data-canvas-text')) {
                            canvasText = hoverTarget.getAttribute('data-canvas-text');
                        } else {
                            canvasText = '';
                        }

                        if (hoverTarget.hasAttribute('data-canvas-icon')) {
                            canvasIcon = hoverTarget.getAttribute('data-canvas-icon');
                        } else {
                            canvasIcon = '';
                        }

                        canvas.classList.add('js-standard');
                    } else {
                        canvas.classList.remove('js-standard');
                        canvasText = '';
                        canvasIcon = '';
                    }

                    requestAnimationFrame(animate);
                    circle.update();

                    ticking = false;
                } else {
                    canceled = false;
                }
            }

            function canvasMouseMove(e) {
                mouse.x = e.clientX;
                mouse.y = e.clientY;
            }

            function addEvents() {
                document.body.addEventListener('mousemove', canvasMouseMove);

                onWindowResize(() => {
                    canvas.width = window.innerWidth;
                    canvas.height = window.innerHeight;
                    circle.update();
                });

                requestTick();
            }

            function enterTrigger(e) {
                hoverTarget = e.currentTarget;
            }

            function leaveTrigger() {
                hoverTarget = '';
            }

            /*function removeEvents() {
                canvasText = '';
                canvasIcon = '';
                canceled = true;
                cancelAnimationFrame(animate);
                document.body.removeEventListener('mousemove', canvasMouseMove);
                c.clearRect(0, 0, canvas.width, canvas.height);
            }*/

            Array.from(scaleTriggers).forEach(scaleTrigger => {
                scaleTrigger.addEventListener('mouseenter', function () {
                    hoverScaleTrigger = true;
                });

                scaleTrigger.addEventListener('mouseleave', function () {
                    hoverScaleTrigger = false;
                });
            });

            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            const c = canvas.getContext('2d');
            const circle = new Circle(window.innerWidth, window.innerHeight, 0);
            let ticking = false;
            let canceled = false;
            let newRadius;
            let hoverRadius;
            let canvasText = '';
            let canvasIcon = '';
            let hoverTarget = '';

            const img = new Image();
            img.src = '/files/templates/designs/keflico/assets/svg/arrow-long.svg';

            Array.from(canvasMouseTriggers).forEach(mouseTrigger => {
                /*mouseTrigger.addEventListener('mouseenter',addEvents);
                mouseTrigger.addEventListener('mouseleave',removeEvents);*/

                mouseTrigger.addEventListener('mouseenter',enterTrigger);
                mouseTrigger.addEventListener('mouseleave',leaveTrigger);
            });

            addEvents();
        }
    }
}